// ***** start - api base url *****
export const BASE_API_URL: string | undefined = process.env.REACT_APP_API_URL;
// ***** end - api base url *****

// ***** start - endpoint types *****
export type Endpoint = {
  url: string;
};

// Define a type for the keys of the endpoints object
export type EndpointType =
  | "signIn"
  | "otpVerification"
  | "resendOTP"
  | "commodity"
  | "profession"
  | "debtorType"
  | "paymentTerms"
  | "clientType"
  | "commodityArchive"
  | "professionArchive"
  | "debtorTypeArchive"
  | "paymentTermsArchive"
  | "clientTypeArchive"
  | "staffList"
  | "staffStatusToggle"
  | "staffAdd"
  | "changePassword"
  | "forgotPassword"
  | "verifyEmailOtp"
  | "resendEmailOTP"
  | "resetPassword"
  | "getInvitation"
  | "signUp"
  | "cmsContent"
  | "userTypeList"
  | "sendOTP"
  | "cmsPageList";
// ***** end - endpoint types *****

// ***** start - api endpoints object *****
export const endpoints: Record<EndpointType, Endpoint> = {
  // ***** start - authentication module api *****
  signIn: {
    url: "login/",
  },
  otpVerification: {
    url: "verify-otp",
  },
  resendOTP: {
    url: "resend-otp",
  },
  commodity: {
    url: "commodity/",
  },
  profession: {
    url: "profession/",
  },
  debtorType: {
    url: "debtor-type/",
  },
  paymentTerms: {
    url: "payment-term/",
  },
  clientType: {
    url: "client-type/",
  },
  commodityArchive: {
    url: "commodity",
  },
  professionArchive: {
    url: "profession",
  },
  debtorTypeArchive: {
    url: "debtor-type",
  },
  paymentTermsArchive: {
    url: "payment-term",
  },
  clientTypeArchive: {
    url: "client-type",
  },
  staffList: {
    url: "staff/list/",
  },
  staffStatusToggle: {
    url: "staff/status-toggle/",
  },
  staffAdd: {
    url: "staff/sign-up/",
  },
  changePassword: {
    url: "change-password/",
  },
  forgotPassword: {
    url: "forgot-password/",
  },
  verifyEmailOtp: {
    url: "otp-verify",
  },
  resendEmailOTP: {
    url: "resend-email-otp/",
  },
  resetPassword: {
    url: "reset-password/",
  },
  getInvitation: {
    url: "get-invitation/",
  },
  signUp: {
    url: "sign-up/",
  },
  cmsContent: {
    url: "cms-page/",
  },
  userTypeList: {
    url: "user-type-list/",
  },
  sendOTP: {
    url: "send-otp/",
  },
  cmsPageList: {
    url: "cms-page-list/",
  },
  // ***** end - user module api *****
};
// ***** end - api endpoints object *****
